/* Collection Horizontal Showcase JS — 横方向無限ドリフト + 指/マウスドラッグ + 慣性 + wheel水平変換 */
(() => {
  // セクションごとに <script> が重複出力されるため、2回目以降の実行は未初期化セクションの走査だけ行う
  if (window.__jhshowBoot) { window.__jhshowBoot(); return; }

  const FRAME = 1000 / 60;
  const SLOP_TOUCH = 8;
  const SLOP_MOUSE = 5;
  const TAU_FLING = 325;
  const TAU_WHEEL = 100;
  const TAU_RESUME = 450;
  const MAX_VEL = 4;
  // 手で横に動かした行を、慣性が収まってから止めておく時間(ms)。過ぎたら TAU_RESUME で自動ドリフトへ戻す
  const HOLD_AFTER_DRAG_MS = 4000;
  const RESUME_AFTER_TAP_MS = 300;
  const CLICK_GUARD_MS = 350;

  // 行の画像はファーストビューの LCP 画像（fetchpriority=high）が描画されてから取得を始める。帯域とラボ LCP の取り合いを避けるため
  const RELEASE_TIMEOUT_MS = 3000;

  const reduceMq = matchMedia('(prefers-reduced-motion: reduce)');
  const resets = [];
  let released = false;

  function fillSrc(root) {
    const imgs = root.querySelectorAll('.jhshow__media img[data-src]');
    for (let i = 0; i < imgs.length; i++) {
      imgs[i].src = imgs[i].getAttribute('data-src');
      imgs[i].removeAttribute('data-src');
    }
  }

  function release() {
    if (released) return;
    released = true;
    fillSrc(document);
  }

  function scheduleRelease() {
    const afterPaint = () => requestAnimationFrame(() => requestAnimationFrame(release));
    const lcp = document.querySelector('img[fetchpriority="high"]');
    if (!lcp || lcp.complete) {
      afterPaint();
    } else {
      lcp.addEventListener('load', afterPaint, { once: true });
      lcp.addEventListener('error', afterPaint, { once: true });
    }
    setTimeout(release, RELEASE_TIMEOUT_MS);
  }

  function boot() {
    document.querySelectorAll('.jhshow').forEach(initSection);
  }
  window.__jhshowBoot = boot;
  document.addEventListener('shopify:section:load', boot);
  // bfcache 復帰時は pointerup / pointerleave を取りこぼしているので状態を捨てる
  addEventListener('pageshow', (e) => { if (e.persisted) resets.forEach((fn) => fn()); });
  scheduleRelease();
  boot();

  function initSection(section) {
    if (section.__jhshow) return;
    const viewport = section.querySelector('.jhshow__viewport');
    const row = section.querySelector('.jhshow__row');
    if (!viewport || !row) return;
    section.__jhshow = true;
    if (released) fillSrc(section);

    const cards = row.children;
    const repeat = parseInt(section.dataset.repeat, 10) || 3;
    const perSet = Math.floor(cards.length / repeat);
    const v = parseFloat(section.dataset.velocity);
    // data-velocity は px/frame(60fps基準)。px/ms に直して 120Hz 端末でも同じ速さにする
    const base = (isNaN(v) ? -0.6 : v) / FRAME;

    let x = 0;
    let drawn = 0;
    let setWidth = 0;
    let pad = 0;
    let vel = 0;
    let tau = TAU_FLING;
    let drift = 0;
    let resumeAt = 0;
    let resumeTimer = 0;
    let holdPending = false;
    let pendingDx = 0;
    let inView = false;
    let hover = false;
    let focusHold = false;
    let focusCard = null;
    let nativeScroll = false;
    let rafId = 0;
    let lastT = 0;
    let phase = 0; // 0: idle / 1: 方向判定待ち / 2: 横ドラッグ中
    let ptrId = -1;
    let ptrMouse = false;
    let downX = 0;
    let downY = 0;
    let lastX = 0;
    let stopTap = false;
    let clickGuardUntil = 0;
    let dragClass = false;
    let preloaded = false;
    const st = new Float64Array(8);
    const sx = new Float64Array(8);
    let sn = 0;

    function measure() {
      if (perSet < 1 || cards.length <= perSet) return;
      const first = cards[0].getBoundingClientRect().left;
      const w = cards[perSet].getBoundingClientRect().left - first;
      if (!(w > 0)) { setWidth = 0; return; }
      if (setWidth > 0 && w !== setWidth) x = x / setWidth * w;
      setWidth = w;
      pad = Math.max(0, first - row.getBoundingClientRect().left);
      wake();
    }

    // rAF は動かすものがある間だけ。状態を変えた側が必ず wake() を呼ぶ
    function wake() {
      if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = 0; }
      if (rafId || !inView) return;
      lastT = 0;
      rafId = requestAnimationFrame(tick);
    }

    function resume() {
      resumeTimer = 0;
      resumeAt = 0;
      wake();
    }

    function startHold(now) {
      holdPending = false;
      resumeAt = now + HOLD_AFTER_DRAG_MS;
    }

    function tick(t) {
      rafId = 0;
      const dt = lastT ? Math.min(t - lastT, 64) : FRAME;
      lastT = t;

      const dragging = phase === 2;
      if (dragging !== dragClass) {
        dragClass = dragging;
        section.classList.toggle('is-dragging', dragging);
        if (dragging && !preloaded) preload();
      }
      if (!(setWidth > 0)) return;

      if (focusCard) {
        // キーボードフォーカス時にブラウザが overflow:hidden をスクロールさせるのを戻し、カードを左端へ
        x = -((focusCard.offsetLeft - cards[0].offsetLeft) % setWidth);
        viewport.scrollLeft = 0;
        section.scrollLeft = 0;
        focusCard = null;
        vel = 0;
      }
      if (nativeScroll) {
        // 読み上げ・ページ内検索などでブラウザが viewport 自体をスクロールした分は transform 側へ吸収する
        nativeScroll = false;
        const s = viewport.scrollLeft;
        if (s !== 0) {
          pendingDx -= s;
          viewport.scrollLeft = 0;
        }
      }
      let dx = pendingDx;
      pendingDx = 0;
      if (!dragging) {
        dx += vel * dt;
        vel *= Math.exp(-dt / tau);
        if (Math.abs(vel) < 0.01) vel = 0;
      }
      if (holdPending && phase === 0 && vel === 0) startHold(t);

      const auto = base !== 0 && !reduceMq.matches && !hover && !focusHold && phase === 0;
      const drifting = auto && !holdPending && t >= resumeAt;
      if (drifting) {
        drift += (1 - drift) * (1 - Math.exp(-dt / TAU_RESUME));
        dx += base * drift * dt;
      } else {
        drift = 0;
      }
      if (dx !== 0) {
        x += dx;
        // 行頭の padding-left 区間だけは周期の外（複製が無い）。巡回範囲を padding 分ずらして継ぎ目を消す
        if (x > 0) x = x % setWidth - setWidth;
        else if (x <= -setWidth - pad) x = (x + pad) % setWidth - pad;
      }
      const r = Math.round(x * 100) / 100;
      if (r !== drawn) {
        row.style.transform = 'translateX(' + r + 'px)';
        drawn = r;
      }

      if (!inView) return;
      if (drifting || vel !== 0) {
        rafId = requestAnimationFrame(tick);
      } else if (auto) {
        // 再開待ちの間は rAF を回さず、タイマー1本で起こす
        resumeTimer = setTimeout(resume, Math.max(0, resumeAt - performance.now()));
      }
    }

    // 複製セットの同一商品画像を同時にロード済みにする（wrap で別セットへ切り替わる瞬間の白抜け防止。同一URLなのでキャッシュヒット）
    function syncClones(img) {
      const card = img.closest('.jhshow__card');
      const idx = Array.prototype.indexOf.call(cards, card);
      if (idx < 0 || perSet < 1) return;
      for (let i = idx % perSet; i < cards.length; i += perSet) {
        const im = cards[i].querySelector('img');
        if (im && im !== img && im.loading === 'lazy') im.loading = 'eager';
      }
    }

    function preload() {
      preloaded = true;
      release();
      const imgs = row.querySelectorAll('img[loading="lazy"]');
      for (let i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
    }

    function sample(e) {
      st[sn & 7] = e.timeStamp;
      sx[sn & 7] = e.clientX;
      sn++;
    }

    function flingVelocity(now) {
      const n = Math.min(sn, 8);
      if (n < 2) return 0;
      const li = (sn - 1) & 7;
      if (now - st[li] > 80) return 0;
      let oi = li;
      for (let k = 1; k < n; k++) {
        const i = (sn - 1 - k) & 7;
        if (st[li] - st[i] > 100) break;
        oi = i;
      }
      const d = st[li] - st[oi];
      return d > 0 ? (sx[li] - sx[oi]) / d : 0;
    }

    function endGesture(dragged, guardClick) {
      phase = 0;
      ptrId = -1;
      removeEventListener('pointermove', onMove);
      removeEventListener('pointerup', onUp);
      removeEventListener('pointercancel', onCancel);
      removeEventListener('blur', abort);
      const now = performance.now();
      if (dragged) holdPending = true;
      else resumeAt = Math.max(resumeAt, now + RESUME_AFTER_TAP_MS);
      clickGuardUntil = guardClick ? now + CLICK_GUARD_MS : 0;
      wake();
    }

    function onDown(e) {
      if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0) || !(setWidth > 0)) return;
      if (phase !== 0) endGesture(phase === 2, false);
      phase = 1;
      ptrId = e.pointerId;
      ptrMouse = e.pointerType === 'mouse';
      downX = lastX = e.clientX;
      downY = e.clientY;
      stopTap = Math.abs(vel) > 0.3;
      vel = 0;
      clickGuardUntil = 0;
      sn = 0;
      sample(e);
      addEventListener('pointermove', onMove, { passive: true });
      addEventListener('pointerup', onUp, { passive: true });
      addEventListener('pointercancel', onCancel, { passive: true });
      addEventListener('blur', abort);
      wake();
    }

    function onMove(e) {
      if (e.pointerId !== ptrId) return;
      sample(e);
      if (phase === 1) {
        const dx = Math.abs(e.clientX - downX);
        const dy = Math.abs(e.clientY - downY);
        const slop = ptrMouse ? SLOP_MOUSE : SLOP_TOUCH;
        if (dx >= slop && dx > dy) {
          phase = 2;
          lastX = e.clientX;
          clickGuardUntil = Infinity;
          // pointerdown 時点で capture するとリンクの click が viewport に付け替わりタップ遷移が死ぬため、横確定後のみ
          if (ptrMouse) { try { viewport.setPointerCapture(ptrId); } catch (_) {} }
          wake();
        } else if (dy >= slop) {
          endGesture(false, false);
        }
        return;
      }
      pendingDx += e.clientX - lastX;
      lastX = e.clientX;
      wake();
    }

    function onUp(e) {
      if (e.pointerId !== ptrId) return;
      if (phase === 2) {
        vel = Math.max(-MAX_VEL, Math.min(MAX_VEL, flingVelocity(e.timeStamp)));
        tau = TAU_FLING;
        endGesture(true, true);
      } else {
        endGesture(false, stopTap);
      }
    }

    // iOS は縦スクロール開始時に pointercancel を送る。慣性は付けずに静かに手放す
    function onCancel(e) {
      if (e.pointerId === ptrId) abort();
    }

    function abort() {
      const dragged = phase === 2;
      vel = 0;
      endGesture(dragged, dragged);
    }

    if (window.PointerEvent) {
      viewport.addEventListener('pointerdown', onDown, { passive: true });
      // 長押しメニューが開くと pointerup が届かないブラウザがある
      viewport.addEventListener('contextmenu', () => { if (phase !== 0) abort(); });
      // 横ドラッグ中に指が縦へぶれてネイティブの縦パンが始まり pointercancel で切れる（iOS）のを防ぐ備え。
      // 止めるのは横と確定した後・指1本のときだけ。縦スワイプとタップは phase 2 にならないので一切触らない。
      // 常設なのは、ジェスチャー開始後に足したリスナーの preventDefault が iOS Safari では効かないため
      viewport.addEventListener('touchmove', (e) => {
        if (phase === 2 && !ptrMouse && e.touches.length === 1 && e.cancelable) e.preventDefault();
      }, { passive: false });
      viewport.addEventListener('click', (e) => {
        if (performance.now() < clickGuardUntil) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (phase !== 2) clickGuardUntil = 0;
      }, true);
      viewport.addEventListener('dragstart', (e) => e.preventDefault());

      // hover 停止はマウスのみ（タッチの擬似 mouseenter で止まったままになるのを防ぐ）
      section.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') hover = true;
      });
      section.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') { hover = false; wake(); }
      });
    }

    section.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || !(setWidth > 0)) return;
      e.preventDefault();
      vel = Math.max(-MAX_VEL, Math.min(MAX_VEL, vel - e.deltaX * 0.4 / FRAME));
      tau = TAU_WHEEL;
      holdPending = true;
      wake();
    }, { passive: false });

    viewport.addEventListener('focusin', (e) => {
      const card = e.target.closest('.jhshow__card');
      let keyboard = false;
      try { keyboard = !!card && card.matches(':focus-visible'); } catch (_) {}
      if (!keyboard) return;
      focusCard = card;
      focusHold = true;
      wake();
    });
    viewport.addEventListener('focusout', () => {
      if (!focusHold) return;
      focusHold = false;
      focusCard = null;
      resumeAt = Math.max(resumeAt, performance.now() + RESUME_AFTER_TAP_MS);
      wake();
    });

    viewport.addEventListener('scroll', () => {
      nativeScroll = true;
      wake();
    }, { passive: true });

    row.addEventListener('load', (e) => {
      if (e.target.tagName === 'IMG') syncClones(e.target);
    }, true);
    const loaded = row.querySelectorAll('img');
    for (let i = 0; i < loaded.length; i++) {
      if (loaded[i].complete && loaded[i].naturalWidth > 0) syncClones(loaded[i]);
    }

    new IntersectionObserver((entries) => {
      inView = entries[entries.length - 1].isIntersecting;
      if (inView && !(setWidth > 0)) measure();
      section.classList.toggle('is-active', inView);
      if (inView) {
        release();
        wake();
      } else if (phase === 0) {
        // 画面外では tick が止まる。慣性を持ち越さず、保持時間は画面を出た時点から数える
        vel = 0;
        if (holdPending) startHold(performance.now());
      }
    }, { rootMargin: '-1px 0px' }).observe(section);

    if (window.ResizeObserver) {
      new ResizeObserver(measure).observe(row);
    } else {
      addEventListener('resize', measure);
      addEventListener('load', measure);
      measure();
    }

    resets.push(() => {
      if (phase !== 0) endGesture(false, false);
      hover = false;
      vel = 0;
      pendingDx = 0;
      holdPending = false;
      resumeAt = 0;
      clickGuardUntil = 0;
      cancelAnimationFrame(rafId);
      rafId = 0;
      wake();
    });
  }
})();
